module.exports = __webpack_public_path__ + "img/hawaii.1156d29d.png";